import cn from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import { Card, type CardProperties } from 'ui';

type P = PropsWithChildren<{
  cardProperties?: CardProperties;
  header?: ReactNode;
}>;

const defaultRootClassName = 'fit-content-page-layout__main';
const defaultBodyClassName = 'fit-content-page-layout__body';

const getMergedClassNames = (classNames: CardProperties['classNames']) =>
  typeof classNames === 'function'
    ? (info: Parameters<typeof classNames>[0]) => {
        const resolvedClassNames = classNames(info);

        return {
          ...resolvedClassNames,
          body: cn(defaultBodyClassName, resolvedClassNames?.body),
          root: cn(defaultRootClassName, resolvedClassNames?.root),
        };
      }
    : {
        ...classNames,
        body: cn(defaultBodyClassName, classNames?.body),
        root: cn(defaultRootClassName, classNames?.root),
      };

const FitContentPageLayout = ({ cardProperties, children, header }: P) => {
  const { classNames, ...restMainContentProperties } = cardProperties ?? {};
  const mergedClassNames = getMergedClassNames(classNames);

  return (
    <div className="fit-content-page-layout">
      {header}
      <Card classNames={mergedClassNames} marginBottom={false} {...restMainContentProperties}>
        {children}
      </Card>
    </div>
  );
};

export default FitContentPageLayout;
